import { useQuery } from '@tanstack/react-query';
import type { OutageData } from '@/types/outage';
import { REFRESH_INTERVALS } from '../constants';

export function useOutages() {
  return useQuery({
    queryKey: ['outages', 'current'],
    queryFn: async (): Promise<OutageData> => {
      const res = await fetch('/api/outages/current');
      if (!res.ok) throw new Error('Failed to fetch outages');
      return res.json();
    },
    refetchInterval: REFRESH_INTERVALS.current,
    staleTime: 30000,
  });
}
